import React from "react";
import { useField } from "formik";
import { Input } from "antd";
import "./FormInput.scss";

const FormInput = ({ label,placeholder = 'Enter text', ...props}) => {
  const [field, meta] = useField(props);

  return (
    <div className="mainWrapForInput" style={{ width: "100%" }}>
      {/* style={{ marginBottom: "15px" }} */}
      {/* {label && (
        <label
          htmlFor={props.name}
          style={{ display: "block", marginBottom: 4 }}
        >
          {label}
        </label>
      )} */}
      <Input
        {...field}
        {...props}
        style={{
          height: 44,
          borderColor: meta.touched && meta.error ? "#ff4d4f" : undefined,
        }}
         placeholder={placeholder}
      />
      {meta.touched && meta.error && (
        <div
          className="errorMsg"
          style={{
            color: "#ff4d4f",
            marginTop: 4,
            fontSize: 12,
            display: "flex",
          }}
        >
          {meta.error}
        </div>
      )}
    </div>
  );
};

export default FormInput;
